import logo from 'assets/icons/logo.svg'
import { Link } from 'react-router-dom'

function NotFoundContent() {
  return (
    <section className='flex min-h-screen items-center justify-center bg-white'>
      <div className='mt-10 flex w-11/12 flex-col gap-8 text-purple md:mt-20 md:w-9/12'>
        <nav className='flex items-center justify-start gap-2 text-xl text-purple'>
          <Link to='/' className='transition-colors duration-500 hover:text-green'>
            Início
          </Link>
          <span>Em Construção</span>
        </nav>

        <div className='flex w-full items-center justify-between gap-4'>
          <div className='flex flex-1 flex-col gap-4'>
            <h1 className='text-5xl font-semibold'>Em Breve</h1>
            <p className='text-xl md:text-2xl'>
              Estamos trabalhando para trazer uma experiência única e transformadora. Em breve, esta página ganhará vida
              com conteúdos inovadores e um design pensado para inspirar e conectar você.
            </p>
          </div>
          <div className='hidden flex-1 flex-col gap-4 md:flex'>
            <picture>
              <img src={logo} alt='Logo da Agência Dorac, formado pelas letras A e D estilizadas' className='w-10/12' />
            </picture>
          </div>
        </div>
      </div>
    </section>
  )
}

export default NotFoundContent
